export default __webpack_public_path__ + "static/media/Scholigit.79556c31.svg";